export default [
    {
        path: 'incident',
        name: 'Incident',
        component: () => import("@/views/Page/Incident/Incident.vue"),
        meta: {
            title: 'Incident Management',
        },
    },
    {
        path: 'incident/:id',
        name: 'IncidentDetails',
        component: () => import("@/views/Page/Incident/IncidentDetails.vue"),
        meta: {
            title: 'Incident Details',
        },
    }
];
